import React from 'react';
import './LoadingAnimation.css'; // Import CSS file for styling

function LoadingAnimation() {
  return (
    <div className="loading-container">
      <img src="/RealLogo.png" alt="Loading" className="loading-image" />
    </div>
  );
}

export default LoadingAnimation;